import React, {Component, useRef, useEffect} from 'react';
import {connect} from 'react-redux';
import {CardMedia, Grid} from '@material-ui/core';
import Carousel from 'react-material-ui-carousel';

const EMBED_VIDEO_PATTERN = /(?:youtube\.com\/embed|youtube\.com\/watch|youtu\.be|player\.vimeo\.com|vimeo\.com|dailymotion\.com|wistia\.com|facebook\.com|fb\.watch|twitch\.tv)/i;
const VIDEO_FILE_PATTERN = /\.(mp4|webm|ogg|mov|avi|m4v|mkv)(\?.*)?$/i;

const MIME_TYPES = { mp4: 'video/mp4', webm: 'video/webm', ogg: 'video/ogg', mov: 'video/quicktime', avi: 'video/x-msvideo', m4v: 'video/mp4', mkv: 'video/x-matroska' };

const isEmbeddedVideo = (src) => EMBED_VIDEO_PATTERN.test(src || '');
const isVideoFile = (src) => VIDEO_FILE_PATTERN.test(src || '');
const getMimeType = (src) => {
    const ext = (src || '').split('?')[0].split('.').pop().toLowerCase();
    return MIME_TYPES[ext] || '';
};

function VideoNativeItem({ item }) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;
        const observer = new IntersectionObserver(
            ([entry]) => { entry.isIntersecting ? video.play().catch(() => {}) : video.pause(); },
            { threshold: 0.6 }
        );
        observer.observe(video);
        return () => observer.disconnect();
    }, []);

    return (
        <Grid className="carousel-item">
            <div className="carousel-media carousel-native-video">
                <video ref={videoRef} controls playsInline preload="auto" muted>
                    <source src={item.src} type={getMimeType(item.src)} />
                </video>
            </div>
        </Grid>
    );
}

const getEmbedSrc = (src) => {
    if (!src) return src;

    try {
        const url = new URL(src, window.location.href);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('mute', '1');
        url.searchParams.set('controls', '1');
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('rel', '0');
        url.searchParams.set('modestbranding', '1');
        return url.toString();
    } catch {
        return src;
    }
};

function Item({ item }) {
    const isVideo = item.element === 'video' || isVideoFile(item.src);

    if (isVideo && isEmbeddedVideo(item.src)) {
        return (
            <Grid className="carousel-item">
                <div className="carousel-media carousel-media-embed">
                    <iframe
                        src={getEmbedSrc(item.src)}
                        title={item.title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    />
                </div>
            </Grid>
        );
    }

    if (isVideo) {
        return <VideoNativeItem item={item} />;
    }

    return (
        <Grid className="carousel-item">
            <CardMedia
                className="carousel-media"
                image={item.src}
                title={item.title}
                onClick={() => window.open(item.link)}
            />
        </Grid>
    );
}

class CarouselDefault extends Component {
    constructor(props) {
        super(props);
        this.state = { activeIndex: 0 };
    }

    handleResponse = (value) => {
        if (value) {
            const {incomingResponses} = this.props;
            this.props.dispatch({type: 'synthetic', detail: {type: 'visitor_send_msg', msg: value}});
            incomingResponses(value);
        }
    };

    render() {
        const {items} = this.props;
        const {activeIndex} = this.state;
        const activeItem = items?.[activeIndex];

        return (
            items?.length > 0 &&
            <div className="carousel-wrapper">
                <Carousel
                    className="carousel"
                    autoPlay={false}
                    animation="slide"
                    indicators={true}
                    timeout={200}
                    navButtonsAlwaysVisible={true}
                    fullHeightHover={false}
                    navButtonsWrapperProps={{
                        style: {
                            height: '60px',
                            top: 'calc(35% - 30px)'
                        }
                    }}
                    indicatorContainerProps={{
                        style: { marginTop: '4px', marginBottom: '2px' }
                    }}
                    onChange={(index) => this.setState({activeIndex: index})}
                >
                    {
                        items.map((item, i) => (
                            <Item item={item} key={i} />
                        ))
                    }
                </Carousel>
                {activeItem?.title && (
                    <div
                        className={
                            activeItem.element === 'video' || isVideoFile(activeItem.src)
                                ? 'carousel-video-caption'
                                : 'carousel-media-caption'
                        }
                        onClick={() => this.handleResponse(activeItem.value)}
                    >
                        {activeItem.title}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state
    };
};

const action_carousel = connect(
    mapStateToProps
)(CarouselDefault);

export default action_carousel;
